import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import AirportPicker from './airport-picker'
import RangeMap from '../../components/range-map/range-map'

const inputWrapperStyles = {
  maxWidth: '400px',
  marginLeft: 'auto',
  marginRight: 'auto',
}

const RangeMapComponent = props => {
  const [option, setOption] = useState(null)
  const [rangeMap, setRangeMap] = useState(null)
  const mapElement = useRef(null)
  useEffect(() => {
    setRangeMap(new RangeMap(mapElement.current, props))
  }, [])
  const onChange = selectedOption => {
    setOption(selectedOption)
    rangeMap.setCenter({
      lat: selectedOption.airport.lat,
      lng: selectedOption.airport.lng,
    })
  }
  const { t } = useTranslation()
  return (
    <>
      <div
        className='mb-64 range-map__input-container'
        style={inputWrapperStyles}
      >
        <div className='range-map__city'>
          <AirportPicker
            placeholder={t('Enter city')}
            value={option}
            onChange={onChange}
            clearable
          />
        </div>
        {/* <button
          type='button'
          className='range-map__delete-icon'
          aria-label='Clear'
          onClick={setOption.bind(null)}
        ></button> */}

        <div className='range-map__decor'>
          <span
            className='title__decor'
            style={{ backgroundImage: `url(${props.decorImage})` }}
          />
        </div>
      </div>

      <div ref={mapElement} className='range-map__map' />
    </>
  )
}

RangeMapComponent.propTypes = {
  decorImage: PropTypes.string,
}

export default RangeMapComponent
